import GoogleCertificateEpicClient from 'bundles/epic/clients/GoogleCertificate';

export const generateImpressionForShowNewXdpValueProps = () => GoogleCertificateEpicClient.get('showNewXdpValueProps');

export const isShowNewXdpValuePropsEnabled = () => GoogleCertificateEpicClient.preview('showNewXdpValueProps');
